import { AdaptiveRichardsonDeriv } from './AdaptiveRichardsonDeriv';

/**
 * Newton's method for single variable convex optimization
 * This utilizes the nested richardson extrapolation method for derivative estimation
 * within a tolerance.
 * @param {function} f Objective function
 * @param {number} x0 Initial guess
 * @param {number} tol Convergence tolerance
 * @param {number} maxIter Maximum number of iterations
 * @param {object} derivativeOptions Options for adaptiveRichardsonDeriv
 * @returns {object} Optimization result
 */
export function NewtonsOpt1d(f, x0, tol = 1e-8, maxIter = 100, derivativeOptions = {}) {
  const derivH0 = derivativeOptions.h0 || 1e-2;
  const derivErrorTol = derivativeOptions.errorTol || 1e-8;
  const maxK = derivativeOptions.maxK || 5;
  const dfdx = (x) => AdaptiveRichardsonDeriv(f, x, derivH0, derivErrorTol, maxK, 1, false);
  const d2fdx2 = (x) => AdaptiveRichardsonDeriv(f, x, derivH0, derivErrorTol, maxK, 2, false);

  let x = x0;
  let dfdxVal, d2fdx2Val, xNew;
  for (let i = 1; i <= maxIter; i++) {
    dfdxVal = dfdx(x);
    d2fdx2Val = d2fdx2(x);
    xNew = x - dfdxVal / d2fdx2Val;
    if (Math.abs(xNew - x) < tol)
      return {
        xMin: xNew,
        iterations: i,
        success: true
      };
    x = xNew;
  }
  return {
    xMin: x,
    iterations: maxIter,
    success: false,
    reason: 'Exceeded max iterations'
  };
}
